var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCadastro({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.49951C0 1.12087 1.19604 0 2.66713 0H9.33495V4.99902C9.33495 5.6903 9.93089 6.24878 10.6685 6.24878H16.0028V11.158L12.3855 14.5479C11.9562 14.9502 11.6562 15.4501 11.5103 16.0008L10.731 18.926C10.6352 19.2853 10.656 19.6602 10.7852 20H2.66713C1.19604 20 0 18.8791 0 17.5005V2.49951ZM16.0028 4.99902H10.6685V0L16.0028 4.99902ZM22.9123 9.20523L23.5124 9.76762C24.1625 10.3769 24.1625 11.365 23.5124 11.9781L22.2872 13.1263L19.3284 10.3534L20.5536 9.20523C21.2037 8.59598 22.258 8.59598 22.9123 9.20523ZM12.9981 16.2859L18.3824 11.24L21.3412 14.0129L15.9569 19.0549C15.7861 19.215 15.5735 19.3283 15.336 19.3829L12.8314 19.9688C12.6022 20.0234 12.3646 19.9609 12.198 19.8047C12.0313 19.6485 11.9646 19.4259 12.0229 19.2111L12.648 16.8639C12.7064 16.6452 12.8272 16.4421 12.9981 16.282V16.2859Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadastro);
export default __webpack_public_path__ + "static/media/Cadastro.71a6d54b4e3fe6c4948822cc5d1d1888.svg";
export { ForwardRef as ReactComponent };